import React, { FC } from 'react';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Page from 'components/Page';
import UserProfile from 'components/UserProfile';

import { withData } from 'lib';
import { AccountProfilePageQuery } from '__generated__/AccountProfilePageQuery.graphql';

const query = graphql`
  query AccountProfilePageQuery {
    viewer {
      ...UserProfile_user
    }
  }
`;

type Props = {
  preloadedQuery: PreloadedQuery<AccountProfilePageQuery>;
};

const AccountProfilePage: FC<Props> = ({ preloadedQuery }) => {
  const data = usePreloadedQuery<AccountProfilePageQuery>(
    query,
    preloadedQuery
  );

  return (
    <Page breadcrumbs={[{ name: 'Vartotojo profilis' }]}>
      <UserProfile user={data.viewer!} />
    </Page>
  );
};

export default withData<AccountProfilePageQuery>({
  query,
  variables: ({ currentUser }) => ({
    first: currentUser.itemsPerPage,
  }),
})(AccountProfilePage);
